import { IRequest } from '@r1-frontend/shared/types/IRequest';

/*
* Создание из строки Qr кода
* https://master.api-pay.sandbox.d2c.r-one.io/docs/v1#/Qr/77410f26d166a98d48d84a242c4b54fc
*/

export const getQrCode = (providerId: number, qrLink: string): IRequest => {

    return {
        uri: `/qr/index?url=${encodeURIComponent(qrLink)}`,
        method: 'GET',
        queryParams: {
            providerId,
        },
        withProvider: true,
    };
};
